import { BREAKPOINT } from '@/constants/enum';
import { useMediaQuery } from 'react-responsive';

interface IProps {
  children: React.ReactNode;
}

export default function CustomGridLayoutPreview(props: IProps) {
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.SM });
  return <div className={`content-between ${isMobile ? 'flex-column' : ''}`}>{props.children}</div>;
}
